@if(type !== 'radio') {
  <div [ngClass]="class">

    @if (formGroup && controlName) {
      <div [formGroup]="formGroup">
        <!-- formGroup -->
        <mat-checkbox class="custom-color"

                      [formControlName]="controlName"
                      [value]="value">{{ label }}</mat-checkbox>
      </div>
    } @else {
      <div >
        <!-- not formGroup -->
        <mat-checkbox class="custom-color"
                      [checked]="checked"
                      (change)="change.emit($event)"
                      [disabled]="disabled" [value]="value">{{ label }}</mat-checkbox>
      </div>
    }

  </div>
} @else {
  <div [ngClass]="class">

    @if (formGroup && controlName) {
      <div [formGroup]="formGroup">
        <!-- formGroup -->
        <mat-radio-group [formControlName]="controlName">
          @for (item of options; track item.value) {
            <mat-radio-button class="custom-color"
                              [value]="item.value">{{ item.label }}</mat-radio-button>
          }

        </mat-radio-group>

      </div>
    } @else {
      <div >
        <!-- not formGroup -->
        <mat-radio-group [(ngModel)]="value" [disabled]="disabled"></mat-radio-group>
        @for (item of options; track item.value) {
          <mat-radio-button class="custom-color"
                            [disabled]="item.disabled"
                            [value]="item.value">{{ item.label }}</mat-radio-button>
        }
      </div>
    }

  </div>
}

